import { Middleware, Action } from 'redux'

type ActionListener = (action: Action, prevState: App.State, nextState: App.State) => void

const listeners = new Set<ActionListener>()

export function subscribeToActions(listener: ActionListener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const actionRecorderMiddleware: Middleware<object, App.State> = (store) => (next) => (action) => {
  if (listeners.size === 0) {
    return next(action)
  }

  const prevState = store.getState()
  const result = next(action)
  const nextState = store.getState()

  listeners.forEach((listener) => {
    listener(action as Action, prevState, nextState)
  })

  return result
}

export default actionRecorderMiddleware
